import { MissionData } from '../blocks/mission'
import template from './templates/RJS04.rbxl'
import thumbnail1 from './thumbnails/RJS04/HomeBase.png'
import thumbnail2 from './thumbnails/RJS04/Bat.png'
import thumbnail3 from './thumbnails/RJS04/Ball.png'
import thumbnail4 from './thumbnails/RJS04/HomeRunZone.png'
const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}, {}],
  objects: [
    {
      name: '①ホームベース',
      thumbnail: thumbnail1,
    },
    {
      name: '②バット',
      thumbnail: thumbnail2,
    },
    {
      name: '③ボール',
      thumbnail: thumbnail3,
    },
    {
      name: '④ホームランゾーン',
      thumbnail: thumbnail4,
    },
  ],
}

export default mission
